import {type StateTree} from 'pinia';

export interface LoadingStoreState extends StateTree {
    show: boolean;
    mode: string;
}

export const state = (): LoadingStoreState => ({
    show: false,
    mode: "dark"
});
